import { ChartType } from "../../../../store/enums";

const OptionSettings = {
	[ChartType.BarChart]: {
		yAxisRangeOptions: [
			{ value: "TOP_5", label: "Top 5" },
			{ value: "TOP_10", label: "Top 10" },
			{ value: "TOP_25", label: "Top 25" },
			{ value: "BOTTOM_5", label: "Bottom 5" },
			{ value: "BOTTOM_10", label: "Bottom 10" },
			{ value: "BOTTOM_25", label: "Bottom 25" },
		],
	},
	[ChartType.ColumnChart]: {
		xAxisRangeOptions: [
			{ value: "TOP_5", label: "Top 5" },
			{ value: "TOP_10", label: "Top 10" },
			{ value: "TOP_25", label: "Top 25" },
			{ value: "BOTTOM_5", label: "Bottom 5" },
			{ value: "BOTTOM_10", label: "Bottom 10" },
			{ value: "BOTTOM_25", label: "Bottom 25" },
		],
	},
	[ChartType.NineBox]: {
		dataSeriesRangeOptions: [
			{ value: "TOP_25", label: "Top 25" },
			{ value: "TOP_50", label: "Top 50" },
			{ value: "TOP_100", label: "Top 100" },
			{ value: "TOP_200", label: "Top 200" },
			{ value: "BOTTOM_25", label: "Bottom 25" },
			{ value: "BOTTOM_50", label: "Bottom 50" },
			{ value: "BOTTOM_100", label: "Bottom 100" },
			{ value: "BOTTOM_200", label: "Bottom 200" },
		],
	},
	[ChartType.ScatterChart]: {
		dataSeriesRangeOptions: [
			{ value: "TOP_25", label: "Top 25" },
			{ value: "TOP_50", label: "Top 50" },
			{ value: "TOP_100", label: "Top 100" },
			{ value: "TOP_200", label: "Top 200" },
			{ value: "BOTTOM_25", label: "Bottom 25" },
			{ value: "BOTTOM_50", label: "Bottom 50" },
			{ value: "BOTTOM_100", label: "Bottom 100" },
			{ value: "BOTTOM_200", label: "Bottom 200" },
		],
	},
	[ChartType.TrendlineChart]: {
		dataSeriesRangeOptions: [
			{ value: "year", label: "Yearly" },
			{ value: "quarter", label: "Quarterly" },
			{ value: "month", label: "Monthly" },
		],
	},
};

export const dataSeriesTooltipText =
	"The data series represents the main topic of the chart.  For example, if you wanted to create a Top 10 bar chart of review subjects based on their average score for a question, the review subject field would be the Data Series for the chart.";
export const metricTooltipText =
	"The Metric for a chart represents the measurement displayed in the visualization. For most charts, a single metric is sufficient to render the chart. However, some charts, namely the Scatter and the 9-box charts, require two metrics to render the chart.";

export default OptionSettings;
